<div class="q-score-card">
  <div class="p-3 text-center">
    <img [src]="statTitle" alt="" />
    <div class="q-score-card-subtitle">
      <h6 class="q-heading">
        {{ statSubtitle }}
      </h6>
    </div>
    <div class="my-4 para">
      {{ description }}
    </div>
    <div class="w-xl-75 mx-xl-auto gotoUrlDiv">
      <button class="submit-btn bg-orgclr" (click)="goToUrl()">{{ buttontitle }}</button>
    </div>
  </div>
</div>